import "./modules/common";
import {
  LoginForm,
} from "spiritweb.packages.web-account";
import VueApp from "~/Scripts/new/vueApp";
import AccountInfoList from "~/Components/Accounts/AccountInfoList.vue";

new VueApp( {
  name: "Login",
  components: {
    LoginForm,
    AccountInfoList,
  },
  methods: {
    loggedIn ( redirectUrl, webUserTypeId ) {
      if ( webUserTypeId === 8 || webUserTypeId === 9 ) {
        window.location.replace( "/my-account/my-magazines/" );
      } else {
        window.location = redirectUrl;
      }
    },
  },

} );
